// extracted by mini-css-extract-plugin
module.exports = {"FindSchools":"FindSchools_FindSchools__1YTPB","Colleges":"FindSchools_Colleges__3lQOk","College":"FindSchools_College__31tAo","CollegeName":"FindSchools_CollegeName__1FLCd"};